import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable, Injector } from '@angular/core';

import { StorageService } from '../shared/services/storage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const storageService = this.injector.get(StorageService);

    if (storageService.isLoggedIn()) {
      const user = storageService.getUser();
      const authRequest = request.clone({
        setHeaders: { Authorization: `Bearer ${user.token}` },
      });

      return next.handle(authRequest);
    } else {
      return next.handle(request);
    }
  }
}
